import { defaultStatus } from "../defaultState/defaultState";
import {
  ADD_FLOOR_FAILURE,
  ADD_FLOOR_REQUEST,
  ADD_FLOOR_SUCCESS,
  DELETE_FLOOR_FAILURE,
  DELETE_FLOOR_REQUEST,
  DELETE_FLOOR_SUCCESS,
  FETCH_FLOOR_FAILURE,
  FETCH_FLOOR_REQUEST,
  FETCH_FLOOR_SUCCESS,
  FETCH_LIST_All_FLOOR_FAILURE,
  FETCH_LIST_All_FLOOR_REQUEST,
  FETCH_LIST_All_FLOOR_SUCCESS,
  FETCH_LIST_AllS_FLOOR_FAILURE,
  FETCH_LIST_AllS_FLOOR_REQUEST,
  FETCH_LIST_AllS_FLOOR_SUCCESS,
  FETCH_LIST_FLOOR_FAILURE,
  FETCH_LIST_FLOOR_REQUEST,
  FETCH_LIST_FLOOR_SUCCESS,
  RESET_CURRENT_FLOOR,
  UPDATE_FLOOR_FAILURE,
  UPDATE_FLOOR_REQUEST,
  UPDATE_FLOOR_SUCCESS,
  FETCH_COMMON_FLOOR_REQUEST,
  FETCH_COMMON_FLOOR_SUCCESS,
  FETCH_COMMON_FLOOR_FAILURE,
} from "./floorType";

const initialState = {
  floors: [],
  currentFloor: null,
  fetchFloors: { ...defaultStatus },
  fetchAllFloors: { ...defaultStatus },
  fetchAllFloor: { ...defaultStatus },
  fetchFloor: { ...defaultStatus },
  addFloor: { ...defaultStatus },
  updateFloor: { ...defaultStatus },
  deleteFloor: { ...defaultStatus },
  fetchCommonFloors: { ...defaultStatus },
  commonFloors: [],
  formMode: null, // 'add' or 'edit'
};

const floorReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_LIST_AllS_FLOOR_REQUEST:
      return {
        ...state,
        fetchAllFloor: { ...state.fetchAllFloor, inProgress: true },
      };
    case FETCH_LIST_AllS_FLOOR_SUCCESS:
      return {
        ...state,
        fetchAllFloor: {
          ...state.fetchAllFloor,
          success: true,
          inProgress: false,
          floors: payload?.floors,
        },
      };
    case FETCH_LIST_AllS_FLOOR_FAILURE:
      return {
        ...state,
        fetchAllFloor: {
          ...state.fetchAllFloor,
          error: true,
          errorMessage: payload.error,
        },
      };
    case FETCH_LIST_All_FLOOR_REQUEST:
      return {
        ...state,
        fetchAllFloors: { ...state.fetchAllFloors, inProgress: true },
      };
    case FETCH_LIST_All_FLOOR_SUCCESS:
      return {
        ...state,
        fetchAllFloors: {
          ...state.fetchAllFloors,
          success: true,
          inProgress: false,
          floors: payload?.floors,
        },
      };
    case FETCH_LIST_All_FLOOR_FAILURE:
      return {
        ...state,
        fetchAllFloors: {
          ...state.fetchAllFloors,
          error: true,
          errorMessage: payload.error,
        },
      };
    // List Floors
    case FETCH_LIST_FLOOR_REQUEST:
      const { blockId, pageNo } = payload;

      return {
        ...state,
        fetchFloors: {
          ...state.fetchFloors,
          inProgress: true,
          blockId,
          pageNo,
        },
      };
    case FETCH_LIST_FLOOR_SUCCESS:
      return {
        ...state,
        fetchFloors: {
          ...state.fetchFloors,
          success: true,
          inProgress: false,
          floors: payload?.floors,
        },
      };
    case FETCH_LIST_FLOOR_FAILURE:
      return {
        ...state,
        fetchFloors: {
          ...state.fetchFloors,
          error: true,
          errorMessage: payload.error,
        },
      };

    // View single Floor
    case FETCH_FLOOR_REQUEST:
      return {
        ...state,
        fetchFloor: { ...state.fetchFloor, inProgress: true },
      };
    case FETCH_FLOOR_SUCCESS:
      return {
        ...state,
        fetchFloor: { ...state.fetchFloor, success: true, inProgress: false },
        currentFloor: payload.floor,
      };
    case FETCH_FLOOR_FAILURE:
      return {
        ...state,
        fetchFloor: {
          ...state.fetchFloor,
          error: true,
          errorMessage: payload.error,
        },
      };

    // Add Floor
    case ADD_FLOOR_REQUEST:
      return {
        ...state,
        addFloor: { ...state.addFloor, inProgress: true },
      };
    case ADD_FLOOR_SUCCESS:
      return {
        ...state,
        addFloor: {
          ...state.addFloor,
          success: true,
          inProgress: false,
          error: false,
          data: payload.floor,
        },
      };
    case ADD_FLOOR_FAILURE:
      return {
        ...state,
        addFloor: {
          ...state.addFloor,
          error: true,
          success: false,
          inProgress: false,
          errorMessage: payload.error,
        },
      };

    // Edit Floor
    case UPDATE_FLOOR_REQUEST:
      return {
        ...state,
        updateFloor: { ...state.updateFloor, inProgress: true },
      };
    case UPDATE_FLOOR_SUCCESS: {
      return {
        ...state,
        updateFloor: {
          ...state.updateFloor,
          success: true,
          inProgress: false,
          error: false,
          data: payload.floor,
        },
      };
    }
    case UPDATE_FLOOR_FAILURE:
      return {
        ...state,
        updateFloor: {
          ...state.updateFloor,
          error: true,
          success: false,
          inProgress: false,
          errorMessage: payload.error,
        },
      };

    // Delete Floor
    case DELETE_FLOOR_REQUEST:
      return {
        ...state,
        deleteFloor: { ...state.deleteFloor, inProgress: true },
      };
    case DELETE_FLOOR_SUCCESS:
      return {
        ...state,
        deleteFloor: { ...state.deleteFloor, success: true, inProgress: false },
        floors: state.floors.filter((floor) => floor.id !== payload.floorId),
        currentFloor:
          state.currentFloor?.id === payload.floorId
            ? null
            : state.currentFloor,
      };
    case DELETE_FLOOR_FAILURE:
      return {
        ...state,
        deleteFloor: {
          ...state.deleteFloor,
          error: true,
          errorMessage: payload.error,
        },
      };

    // Reset current Floor
    case RESET_CURRENT_FLOOR:
      return {
        ...state,
        currentFloor: null,
      };

    case FETCH_COMMON_FLOOR_REQUEST:
      return {
        ...state,
        fetchCommonFloors: { ...state.fetchCommonFloors, inProgress: true },
      };
    case FETCH_COMMON_FLOOR_SUCCESS:
      return {
        ...state,
        fetchCommonFloors: {
          ...state.fetchCommonFloors,
          success: true,
          inProgress: false,
        },
        commonFloors: payload.floors,
      };
    case FETCH_COMMON_FLOOR_FAILURE:
      return {
        ...state,
        fetchCommonFloors: {
          ...state.fetchCommonFloors,
          error: true,
          errorMessage: payload.error,
        },
      };

    default:
      return state;
  }
};

export default floorReducer;
